import Component from '../app/component'
import barba from '@barba/core'

export default class BackgroundComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {
      index: null,
      backgroundsIndex: {
        home: 1,
        about: 2,
        product: 3,
        products: 3,
        collections: 4,
        collection: 4,
        news: 5,
        post: 5,
        contacts: 6
      }
    }
  }

  init () {
    this.data.index = parseInt(this.el.getAttribute('data-index'))

    barba.hooks.afterLeave(data => {
      this.data.index = this.data.backgroundsIndex[data.next.namespace]
    })
  }

  watchIndex(value) {
    if (value === null) {
      return
    }
    [1, 2, 3, 4, 5, 6].forEach(index => this.el.classList.remove(`cm-background--${index}`))
    this.el.classList.add(`cm-background--${value}`)
  }
}
